/*
 * Collection Tabs — tab switching only.
 *
 * Each panel's product row is a shared <snap-slider> (see snap-slider.js /
 * component-snap-slider.css). Panels other than the first start hidden
 * (display:none) so their slider can't measure scroll overflow until shown —
 * on every switch we call the newly-visible panel's slider .refresh() so its
 * nav arrows appear/disappear correctly.
 */
if (!customElements.get('collection-tabs')) {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('.collection-tabs__pill');
      this.panels = this.querySelectorAll('.collection-tabs__panel');

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.switchTab(button.dataset.tab));
      });
    }

    switchTab(tabId) {
      this.buttons.forEach((btn) => {
        const isActive = btn.dataset.tab === tabId;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      this.panels.forEach((panel) => {
        const isActive = panel.id === `collection-tab-${tabId}`;
        panel.classList.toggle('active', isActive);
        if (isActive) {
          const slider = panel.querySelector('snap-slider');
          if (slider && typeof slider.refresh === 'function') slider.refresh();
        }
      });
    }
  }

  customElements.define('collection-tabs', CollectionTabs);
}
